import { useArchivePlaceholderTemplateMutation } from '../../../../generated/graphql'
import useModal from '../../../../lib/hooks/useModal'
import useNotification from '../../../../lib/hooks/useNotification'
import { ConfirmArchiveTemplateModal } from '../../templateModals'

type ConfirmArchivePlaceholderModalWrapperProps = {
  /** ID of Plan */
  id: string
  /** Determines visibility of modal */
  isOpen: boolean
}

const ConfirmArchivePlaceholderModalWrapper = ({
  id,
  isOpen
}: ConfirmArchivePlaceholderModalWrapperProps) => {
  const { hideModal } = useModal()
  const { showErrorNotif } = useNotification()

  const [archivePlaceholderTemplate, mutation] = useArchivePlaceholderTemplateMutation({
    variables: { input: id },
    onError: () => {
      hideModal()
      showErrorNotif('Placeholder could not be archived.', archivePlaceholderTemplate)
    }
  })

  const onConfirm = () => {
    hideModal()
    archivePlaceholderTemplate()
  }

  if (!mutation.called) {
    return <ConfirmArchiveTemplateModal isOpen={isOpen} onConfirm={onConfirm} label="Placeholder" />
  }

  return null
}

export default ConfirmArchivePlaceholderModalWrapper
